import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import { useAsync } from 'react-use';

import { getI18nextInstance, initI18n } from 'i18n';

import { Router } from './Router';

export function App(): JSX.Element {
  const i18nState = useAsync(() => initI18n());
  if (i18nState.loading) return <span />;
  const i18next = getI18nextInstance();

  return (
    <I18nextProvider i18n={i18next}>
      <Router />
    </I18nextProvider>
  );
}
